import { routerMiddleware } from 'connected-react-router/immutable';
import Immutable from 'immutable';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import syncCurrentSlipWithStorage from '../containers/bettingBuddy/storage';
import { sagas } from '../modules';
import analyticsMiddleware from '../utils/analyticsMiddleware';
import createRootReducer from './reducers';

const DEBUG = process.env.NODE_ENV !== 'production';

function* rootSaga() {
  yield all(sagas.map((saga) => fork(saga)));
}

export default function configureStore(history) {
  const initialState = Immutable.Map();
  const sagaMiddleware = createSagaMiddleware();
  const enhancer = compose(
    applyMiddleware(sagaMiddleware, routerMiddleware(history), analyticsMiddleware),
    syncCurrentSlipWithStorage,
    // eslint-disable-next-line no-underscore-dangle
    (DEBUG && window.__REDUX_DEVTOOLS_EXTENSION__) ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
  );
  const store = createStore(createRootReducer(history), initialState, enhancer);
  sagaMiddleware.run(rootSaga);
  return store;
}
